<template>
  <fieldset class="pcd-language-switcher">
    <legend>{{ t('語言 / Language') }}</legend>
    <div class="pcd-language-options">
      <label v-for="option in options" :key="option.value" :class="{ 'is-selected': locale === option.value }">
        <input type="radio" :name="groupName" :value="option.value" :checked="locale === option.value" @change="setLocale(option.value)" />
        <span :lang="option.value">{{ option.label }}</span>
      </label>
    </div>
  </fieldset>
</template>
<script setup>
import { locale, setLocale, t } from '@/i18n';
import { getCurrentInstance } from 'vue';
const groupName = `pcd-language-${getCurrentInstance().uid}`;
const options = [{ value: 'zh-Hant', label: '繁體中文' }, { value: 'zh-Hans', label: '简体中文' }, { value: 'en', label: 'English' }];
</script>
